export default __webpack_public_path__ + "static/media/office-4.a7e88b37.webp";